import { memo, useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { onRateLimitError } from '../../api/client';

/**
 * Global snackbar for rate limit errors.
 * Listens to rate limit events from the API client and displays
 * a non-intrusive notification that auto-dismisses.
 */
export const RateLimitSnackbar = memo(() => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onRateLimitError(() => {
      setOpen(true);
    });
    return unsubscribe;
  }, []);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity="warning"
        variant="filled"
        sx={{ width: '100%' }}
      >
        Slow down! Please wait a moment before trying again.
      </Alert>
    </Snackbar>
  );
});

RateLimitSnackbar.displayName = 'RateLimitSnackbar';

export default RateLimitSnackbar;
